import type { IncomingMessage } from 'http';

/**
 * Retrieves the response strategy set by the Cloudflare mvt-assignment-ewkr.
 * @param req the incoming HTTP request
 */
export const getMvtStrategyFromRequest = (req: IncomingMessage): string | undefined => {
  const value = req?.headers['x-mvt-strategy'];

  return Array.isArray(value) ? value[0] : value;
};
